/* "Acquista Ora" nelle card Carrozzeria Truck: aggiunge al carrello e va dritto alla cassa.
   Il tasto "Carrello" usa invece il <product-form> nativo del tema (drawer/notifica). */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ct-btn--buy');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('ct-btn--loading')) return;
    var id = btn.getAttribute('data-ct-buy');
    if (!id) { window.location.href = '/cart'; return; }

    btn.classList.add('ct-btn--loading');
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', 1);

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) { return r.ok ? '/checkout' : '/cart'; })
      .then(function (dest) { window.location.href = dest; })
      .catch(function () { window.location.href = '/cart'; });
  });
})();
